import * as React from 'react';

/** Play-trekant: peker høyre, sentrert */
export function PlayIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '4px' }} aria-hidden>
      <path d="M8 5v18l16-9L8 5z" fill="currentColor" />
    </svg>
  );
}
